<template>
<SadFaceComponent></SadFaceComponent>
</template>

<script>
import SadFaceComponent from "../components/SadFaceComponent";
export default {
  name: "NoServerSite",
  components: {SadFaceComponent}
}
</script>

<style scoped>

</style>
